/* eslint-disable max-len */
export const sampleData = {
  certificateManager: [
    {
      id: '63f766c7-3f85-4d83-b528-8ddeec5b436c',
      type: 'certificate',
      href: 'https://api.ionos.com/certificatemanager/certificates/63f766c7-3f85-4d83-b528-8ddeec5b436c',
      metadata: {},
      properties: {
        name: 'Default Certificate',
        certificate: 'xxxxxxxxx',
        certificateChain: 'xxxxxxxxx',
        privateKey: 'xxxxxxxxx',
      },
    },
    {
      id: '63f766c7-3f85-4d83-b528-8d4eec5b436c',
      type: 'certificate',
      href: 'https://api.ionos.com/certificatemanager/certificates/63f766c7-3f85-4d83-b528-8ddeec5b436c',
      metadata: {},
      properties: {
        name: 'Certificate Dev',
        certificate: 'xxxxxxxxx',
        certificateChain: 'xxxxxxxxx',
        privateKey: 'xxxxxxxxx',
      },
    },
    {
      id: '63f766c7-3f85-4d83-b528-8dde3c5b436c',
      type: 'certificate',
      href: 'https://api.ionos.com/certificatemanager/certificates/63f766c7-3f85-4d83-b528-8ddeec5b436c',
      metadata: {},
      properties: {
        name: 'Certificate Prod',
        certificate: 'xxxxxxxxx',
        certificateChain: 'xxxxxxxxx',
        privateKey: 'xxxxxxxxx',
      },
    },
  ],

  database: {
    clusters: [
      {
        id: '498ae72f-411f-11eb-9d07-046c59cc737e',
        state: 'CREATED',
        displayName: 'First DB Cluster',
        location: 'de/fra',
        instances: 2,
        ram: 256,
        cores: 4,
        storageSize: 2048,
        storageType: 'HDD',
        metadata: {
          createdDate: {},
          created_by: 'John Doe',
          created_by_user_id: '3',
          last_modified_date: {},
          last_modified_by: 'Jane Doe',
          last_modified_by_user_id: '2',
        },
        connections: [
          {
            datacenterId: 'string',
            lanId: 'string',
            cidr: '192.168.1.100/24',
          },
        ],
        maintenanceWindow: {
          time: '16:30:59',
          dayOfTheWeek: 'Sunday',
        },
      },
      {
        id: '498ae72f-411f-11eb-9d07-546c59cc737e',
        state: 'CREATED',
        displayName: 'Second DB Cluster',
        location: 'de/fra',
        instances: 2,
        ram: 256,
        cores: 4,
        storageSize: 2048,
        storageType: 'HDD',
        metadata: {
          createdDate: {},
          created_by: 'John Doe',
          created_by_user_id: '3',
          last_modified_date: {},
          last_modified_by: 'Jane Doe',
          last_modified_by_user_id: '2',
        },
        connections: [
          {
            datacenterId: 'string',
            lanId: 'string',
            cidr: '192.168.1.100/24',
          },
        ],
        maintenanceWindow: {
          time: '16:30:59',
          dayOfTheWeek: 'Sunday',
        },
      },
    ],
  },

  ALB: {
    id: '15f67991-0f51-4efc-a8ad-ef1fb31a480c',
    type: 'collection',
    href: 'https://api-stage42.k8s.stg.profitbricks.net/cloudapi/v6/datacenters/46775d47-9c4b-4379-9cf0-597e884158f2/applicationloadbalancers/1fda2484-172a-4032-934a-b4e4466ee6cb',
    items: [
      {
        id: '15f67991-0f51-4efc-a8ad-ef1fb31a480c',
        type: 'applicationloadbalancer',
        href: 'https://api-stage42.k8s.stg.profitbricks.net/cloudapi/v6/datacenters/46775d47-9c4b-4379-9cf0-597e884158f2/applicationloadbalancers/1fda2484-172a-4032-934a-b4e4466ee6cb',
        metadata: {
          etag: '45480eb3fbfc31f1d916c1eaa4abdcc3',
          createdDate: '2015-12-04T14:34:09.809Z',
          createdBy: 'user@example.com',
          createdByUserId: 'user@example.com',
          lastModifiedDate: '2015-12-04T14:34:09.809Z',
          lastModifiedBy: 'user@example.com',
          lastModifiedByUserId: '63cef532-26fe-4a64-a4e0-de7c8a506c90',
          state: 'AVAILABLE',
        },
        properties: {
          name: 'My Application Load Balancer',
          listenerLan: 1,
          ips: [
            '81.173.1.2',
            '22.231.2.2',
            '22.231.2.3',
            '22.231.2.4',
            '22.231.2.5',
            '22.231.2.6',
            '22.231.2.7',
          ],
          targetLan: 2,
          lbPrivateIps: [
            '81.173.1.5/24',
            '22.231.2.5/24',
            '22.231.2.5/24',
            '22.231.2.5/24',
            '22.231.2.5/24',
            '22.231.2.5/24',
            '22.231.2.5/24',
          ],
        },
        entities: {
          forwardingrules: {
            id: '15f67991-0f51-4efc-a8ad-ef1fb31a480c',
            type: 'collection',
            href: 'https://api-stage42.k8s.stg.profitbricks.net/cloudapi/v6/datacenters/46775d47-9c4b-4379-9cf0-597e884158f2/applicationloadbalancers/1fda2484-172a-4032-934a-b4e4466ee6cb',
            items: [
              {
                id: '15f67991-0f51-4efc-a8ad-ef1fb31a480c',
                type: 'forwarding-rule',
                href: 'https://api-stage42.k8s.stg.profitbricks.net/cloudapi/v6/datacenters/46775d47-9c4b-4379-9cf0-597e884158f2/applicationloadbalancers/1fda2484-172a-4032-934a-b4e4466ee6cb',
                metadata: {
                  etag: '45480eb3fbfc31f1d916c1eaa4abdcc3',
                  createdDate: '2015-12-04T14:34:09.809Z',
                  createdBy: 'user@example.com',
                  createdByUserId: 'user@example.com',
                  lastModifiedDate: '2015-12-04T14:34:09.809Z',
                  lastModifiedBy: 'user@example.com',
                  lastModifiedByUserId: '63cef532-26fe-4a64-a4e0-de7c8a506c90',
                  state: 'AVAILABLE',
                },
                properties: {
                  name: 'My Application Load Balancer forwarding rule',
                  protocol: 'HTTP',
                  listenerIp: '81.173.1.2',
                  listenerPort: 8080,
                  healthCheck: {
                    clientTimeout: 50,
                  },
                  serverCertificates: [
                    '211c10e4-da0d-4f75-94f3-10808979fb50',
                    'eeee33f9-d812-4fa5-899e-92930b6deb47',
                  ],
                  httpRules: [
                    {
                      name: 'Forward rule',
                      type: 'FORWARD',
                      targetGroup: 'c0545081-3a44-4dcb-b19e-3b758a4b0169',
                      conditions: [
                        {
                          type: 'HEADER',
                          condition: 'STARTS_WITH',
                          negate: false,
                          key: 'forward-at',
                          value: 'Friday',
                        },
                        {
                          type: 'HEADER',
                          condition: 'STARTS_WITH',
                          negate: false,
                          key: 'forward-at',
                          value: 'Friday',
                        },
                        {
                          type: 'HEADER',
                          condition: 'STARTS_WITH',
                          negate: false,
                          key: 'forward-at',
                          value: 'Friday',
                        },
                      ],
                    },
                    {
                      name: 'Static rule',
                      type: 'STATIC',
                      statusCode: 301,
                      responseMessage: 'Application Down',
                      contentType: 'text/html',
                      conditions: [
                        {
                          type: 'HEADER',
                          condition: 'STARTS_WITH',
                          negate: false,
                          key: 'forward-at',
                          value: 'Friday',
                        },
                      ],
                    },
                    {
                      name: 'Redirect rule',
                      type: 'REDIRECT',
                      dropQuery: true,
                      location: 'www.ionos.com',
                      statusCode: 301,
                      conditions: [
                        {
                          type: 'HEADER',
                          condition: 'STARTS_WITH',
                          negate: false,
                          key: 'forward-at',
                          value: 'Friday',
                        },
                      ],
                    },
                  ],
                },
              },
            ],
          },
        },
      },
    ],
  },

  dbaas: {
    mongodb: {
      getAllClusters: {
        type: 'collection',
        id: '498ae72f-411f-11eb-9d07-046c59cc737e',
        items: [
          {
            type: 'collection',
            id: '498ae72f-411f-11eb-9d07-046c59cc737e',
            metadata: {
              createdDate: '2020-12-10T13:37:50+01:00',
              createdBy: 'john.doe@example.com',
              createdByUserId: '87f9a82e-b28d-49ed-9d04-fba2c0459cd3',
              lastModifiedDate: '2020-12-11T13:37:50+01:00',
              lastModifiedBy: 'jane.doe@example.com',
              lastModifiedByUserId: '87f9a82e-b28d-49ed-9d04-fba2c0459cd3',
              state: 'AVAILABLE',
              health: 'HEALTHY',
            },
            properties: {
              displayName: 'MongoDB cluster with template',
              connectionString: 'mongodb://testMongoDBConnectionString',
              templateId: '15c6dd2f-02d2-4987-b439-9a58dd59ecc3',
              mongoDBVersion: '5.0',
              location: 'de/fra',
              instances: 2,
              connections: [
                {
                  datacenterId: '5a029f4a-72e5-11ec-90d6-0242ac120003',
                  lanId: '2',
                  cidrList: [
                    '192.168.1.100/24',
                    '192.168.1.101/24',
                  ],
                },
              ],
              maintenanceWindow: {
                time: '16:30:59',
                dayOfTheWeek: 'Monday',
              },
            },
          },
        ],
        offset: 0,
        limit: 42,
        _links: {
          prev: '<PREVIOUS-PAGE-URI>',
          self: '<THIS-PAGE-URI>',
          next: '<NEXT-PAGE-URI>',
        },
      },
      createCluster: {
        type: 'collection',
        id: '498ae72f-411f-11eb-9d07-046c59cc737e',
        metadata: {
          createdDate: '2020-12-10T13:37:50+01:00',
          createdBy: 'john.doe@example.com',
          createdByUserId: '87f9a82e-b28d-49ed-9d04-fba2c0459cd3',
          lastModifiedDate: '2020-12-11T13:37:50+01:00',
          lastModifiedBy: 'jane.doe@example.com',
          lastModifiedByUserId: '87f9a82e-b28d-49ed-9d04-fba2c0459cd3',
          state: 'AVAILABLE',
        },
        properties: {
          displayName: 'MongoDB cluster',
          ongoDBVersion: '5.0',
          ocation: 'de/fra',
          nstances: 2,
          onnections: [
            {
              datacenterId: '5a029f4a-72e5-11ec-90d6-0242ac120003',
              lanId: '2',
              cidrList: [
                '192.168.1.100/24',
                '192.168.1.101/24',
              ],
            },
          ],
          maintenanceWindow: {
            time: '16:30:59',
            dayOfTheWeek: 'Monday',
          },
        },
      },
      getCluster: {
        type: 'collection',
        id: '498ae72f-411f-11eb-9d07-046c59cc737e',
        metadata: {
          createdDate: '2020-12-10T13:37:50+01:00',
          createdBy: 'john.doe@example.com',
          createdByUserId: '87f9a82e-b28d-49ed-9d04-fba2c0459cd3',
          lastModifiedDate: '2020-12-11T13:37:50+01:00',
          lastModifiedBy: 'jane.doe@example.com',
          lastModifiedByUserId: '87f9a82e-b28d-49ed-9d04-fba2c0459cd3',
          state: 'AVAILABLE',
          health: 'HEALTHY',
        },
        properties: {
          displayName: 'MongoDB cluster',
          mongoDBVersion: '5.0',
          location: 'de/fra',
          instances: 2,
          connectionString: 'mongodb://testMongoDBConnectionString',
          templateId: '15c6dd2f-02d2-4987-b439-9a58dd59ecc3',
          connections: [
            {
              datacenterId: '578a6b3d-7739-4d18-87b0-e2aef8ab21f0',
              lanId: '2',
              cidrList: [
                '192.168.1.100/24',
                '192.168.1.101/24',
              ],
            },
          ],
          maintenanceWindow: {
            time: '16:30:59',
            dayOfTheWeek: 'Monday',
          },
        },
      },
      deleteCluster: {
        type: 'collection',
        id: '498ae72f-411f-11eb-9d07-046c59cc737e',
        metadata: {
          createdDate: '2020-12-10T13:37:50+01:00',
          createdBy: 'john.doe@example.com',
          createdByUserId: '87f9a82e-b28d-49ed-9d04-fba2c0459cd3',
          lastModifiedDate: '2020-12-11T13:37:50+01:00',
          lastModifiedBy: 'jane.doe@example.com',
          lastModifiedByUserId: '87f9a82e-b28d-49ed-9d04-fba2c0459cd3',
          state: 'AVAILABLE',
        },
        properties: {
          displayName: 'MongoDB cluster',
          mongoDBVersion: '5.0',
          location: 'de/fra',
          instances: 2,
          connections: [
            {
              datacenterId: '5a029f4a-72e5-11ec-90d6-0242ac120003',
              lanId: '2',
              cidrList: [
                '192.168.1.100/24',
                '192.168.1.101/24',
              ],
            },
          ],
          maintenanceWindow: {
            time: '16:30:59',
            dayOfTheWeek: 'Monday',
          },
        },
      },
      getTemplates: [
        {
          id: '15c6dd2f-02d2-4987-b439-9a58dd59ecc3',
          cores: 1,
          ram: 4 * 1024,
          storageSize: 30,
        },
        {
          id: '15c6dd2f-02d2-4987-b439-9a58dd59ecc2',
          cores: 1,
          ram: 5 * 1024,
          storageSize: 35,
        },
        {
          id: '15c6dd2f-02d2-4987-b439-9a58dd59ecc1',
          cores: 4,
          ram: 2 * 1024,
          storageSize: 10,
        },
      ],
      getAllVersions: {
        data: [
          {
            name: '2.1',
            swaggerUrl: 'https://api.ionos.com/databases/mongodb/infos/assets/swagger-v2.1.yml',
          },
          {
            name: '5.0',
            swaggerUrl: 'https://api.ionos.com/databases/mongodb/infos/assets/swagger-v2.1.yml',
          },
        ],
      },

      getUsersForCluster: {
        type: 'collection',
        id: '498ae72f-411f-11eb-9d07-046c59cc737e',
        items: [
          {
            type: 'collection',
            metadata: {
              createdDate: '2020-12-10T13:37:50+01:00',
              createdBy: 'john.doe@example.com',
              createdByUserId: '87f9a82e-b28d-49ed-9d04-fba2c0459cd3',
              state: 'CREATING',
            },
            properties: {
              username: 'testusername',
              database: 'admin',
              roles: [
                {
                  role: 'read',
                  database: 'testDB1',
                },
                {
                  role: 'readAnyDatabase',
                  database: 'admin',
                },
              ],
            },
          },
        ],
      },
      createUserForCluster: {
        properties: {
          type: 'collection',
          metadata: {
            createdDate: '2020-12-10T13:37:50+01:00',
            createdBy: 'john.doe@example.com',
            createdByUserId: '87f9a82e-b28d-49ed-9d04-fba2c0459cd3',
            state: 'CREATING',
          },
          properties: {
            username: 'string',
            database: 'admin',
            password: 'string',
            roles: [
              {
                role: 'read',
                database: 'string',
              },
            ],
          },
        },
      },
      updateUserForCluster: {
        properties: {
          type: 'collection',
          metadata: {
            createdDate: '2020-12-10T13:37:50+01:00',
            createdBy: 'john.doe@example.com',
            createdByUserId: '87f9a82e-b28d-49ed-9d04-fba2c0459cd3',
            state: 'CREATING',
          },
          properties: {
            username: 'string',
            database: 'admin',
            password: 'string',
            roles: [
              {
                role: 'read',
                database: 'string',
              },
            ],
          },
        },
      },
      deleteMongoDBUser: {},
      restoreCluster: {},
      getSnapshotsForCluster: {
        type: 'collection',
        id: '498ae72f-411f-11eb-9d07-046c59cc737e',
        items: [
          {
            type: 'collection',
            id: '498ae72f-411f-11eb-9d07-046c59cc737e',
            properties: {
              mongoDBVersion: '5.0',
              size: 150,
              creationTime: '2020-12-10T13:37:50+01:00',
            },
          },
        ],
        offset: 0,
        limit: 42,
        _links: {
          prev: '<PREVIOUS-PAGE-URI>',
          self: '<THIS-PAGE-URI>',
          next: '<NEXT-PAGE-URI>',
        },
      },
    },
  },

  containerRegistry: {
    getAllRegistries: {
      _links: {
        next: 'string',
        previous: 'string',
        self: 'string',
      },
      href: 'string',
      id: 'abc233123123123bbb123a123b',
      items: [
        {
          href: 'string',
          id: 'abc233123123123bbb123a3123b',
          metadata: {
            createdBy: 'string',
            createdByUserId: 'string',
            createdDate: '2022-04-29T12:37:03.944Z',
            lastModifiedBy: 'string',
            lastModifiedByUserId: 'string',
            lastModifiedDate: '2022-04-29T12:37:03.944Z',
            state: 'running',
          },
          properties: {
            garbageCollectionSchedule: {
              days: ['Sunday'],
              time: '01:23:00+00:00',
            },
            hostname: 'test.demo.ionos.local',
            location: 'de/txl',
            maintenanceWindow: {
              days: [
                'Sunday',
              ],
              time: '01:23:00+00:00',
            },
            name: 'Test registry 1',
            storageUsage: {
              bytes: 0,
              updatedAt: '2022-04-29T12:37:03.944Z',
            },
          },
          type: 'string',
        },
        {
          href: 'string',
          id: 'abc233123123123bbb2123a123b',
          metadata: {
            createdBy: 'string',
            createdByUserId: 'string',
            createdDate: '2022-04-29T12:37:03.944Z',
            lastModifiedBy: 'string',
            lastModifiedByUserId: 'string',
            lastModifiedDate: '2022-04-29T12:37:03.944Z',
            state: 'running',
          },
          properties: {
            garbageCollectionSchedule: {
              days: ['Sunday'],
              time: '01:23:00+00:00',
            },
            hostname: 'test.demo.ionos.local',
            location: 'de/txl',
            maintenanceWindow: {
              days: [
                'Sunday',
              ],
              time: '01:23:00+00:00',
            },
            name: 'Test registry 2',
            storageUsage: {
              bytes: 0,
              updatedAt: '2022-04-29T12:37:03.944Z',
            },
          },
          type: 'string',
        },
      ],
      limit: 0,
      nextPageToken: 'string',
      type: 'string',
    },
    getRegistry: {
      href: 'string',
      id: 'abc233123123123bbb123a123b',
      metadata: {
        createdBy: 'string',
        createdByUserId: 'string',
        createdDate: '2022-05-03T10:39:06.440Z',
        lastModifiedBy: 'string',
        lastModifiedByUserId: 'string',
        lastModifiedDate: '2022-05-03T10:39:06.440Z',
        state: 'running',
      },
      properties: {
        garbageCollectionSchedule: {
          days: [
            'Sunday',
          ],
          time: '01:23:00+00:00',
        },
        hostname: 'test.demo.ionos.local',
        location: 'de/txl',
        maintenanceWindow: {
          days: [
            'Sunday',
          ],
          time: '01:23:00+00:00',
        },
        name: 'Test registry 1',
        storageUsage: {
          bytes: 0,
          updatedAt: '2022-05-03T10:39:06.440Z',
        },
      },
      type: 'string',
    },
    getAllTokens: {
      _links: {
        next: 'string',
        previous: 'string',
        self: 'string',
      },
      count: 0,
      href: 'string',
      id: 'abc233123123123bbb123a123b',
      items: [
        {
          href: 'string',
          id: 'abc233123123123bbb123a123b',
          metadata: {
            createdBy: 'string',
            createdByUserId: 'string',
            createdDate: '2022-05-03T10:34:06.530Z',
            lastModifiedBy: 'string',
            lastModifiedByUserId: 'string',
            lastModifiedDate: '2022-05-03T10:34:06.530Z',
            state: 'running',
          },
          properties: {
            credentials: {
              password: 'pass123',
              username: 'username123',
            },
            expiryDate: '2022-05-03T10:34:06.530Z',
            name: 'My first token',
            scopes: [
              {
                actions: [
                  'string',
                ],
                name: 'My first token',
                type: 'string',
              },
            ],
            status: 'enabled',
          },
          type: 'string',
        },
        {
          href: 'string',
          id: 'abc233123123123bbb123a123b',
          metadata: {
            createdBy: 'string',
            createdByUserId: 'string',
            createdDate: '2022-05-03T10:34:06.530Z',
            lastModifiedBy: 'string',
            lastModifiedByUserId: 'string',
            lastModifiedDate: '2022-05-03T10:34:06.530Z',
            state: 'running',
          },
          properties: {
            credentials: {
              password: 'pass234',
              username: 'username433',
            },
            expiryDate: '2022-05-03T10:34:06.530Z',
            name: 'My second token',
            scopes: [
              {
                actions: [
                  'string',
                ],
                name: 'Test name',
                type: 'string',
              },
            ],
            status: 'enabled',
          },
          type: 'string',
        },
        {
          href: 'string',
          id: 'abc233123123123bbb123a123b',
          metadata: {
            createdBy: 'string',
            createdByUserId: 'string',
            createdDate: '2022-05-03T10:34:06.530Z',
            lastModifiedBy: 'string',
            lastModifiedByUserId: 'string',
            lastModifiedDate: '2022-05-03T10:34:06.530Z',
            state: 'running',
          },
          properties: {
            credentials: {
              password: 'pass234',
              username: 'username433',
            },
            expiryDate: '2022-05-03T10:34:06.530Z',
            name: 'My token 3',
            scopes: [
              {
                actions: [
                  'string',
                ],
                name: 'Test name',
                type: 'string',
              },
            ],
            status: 'enabled',
          },
          type: 'string',
        },
      ],
      limit: 0,
      offset: 0,
      total: 0,
      type: 'string',
    },
    getToken: {
      href: 'string',
      id: 'abc233123123123bbb123a123b',
      metadata: {
        createdBy: 'string',
        createdByUserId: 'string',
        createdDate: '2022-05-03T10:38:37.712Z',
        lastModifiedBy: 'string',
        lastModifiedByUserId: 'string',
        lastModifiedDate: '2022-05-03T10:38:37.712Z',
        state: 'running',
      },
      properties: {
        credentials: {
          password: 'string',
          username: 'Test name',
        },
        expiryDate: '2022-05-03T10:38:37.712Z',
        name: 'Test name',
        scopes: [
          {
            actions: [
              'string',
            ],
            name: 'Test name',
            type: 'string',
          },
        ],
        status: 'enabled',
      },
      type: 'string',
    },
    getAllRepositories: { repositories: ['alpine', 'ubuntu', 'another-repo', 'repo-3'] },
    getRepository: { name: 'alpine', tags: ['latest', 'v1', 'v2', 'v3', 'v4'] },
    getRepositoryTags: { name: 'alpine', tags: ['latest', 'v1', 'v2', 'v3', 'v4'] },
    getLocations: {
      id: 'locations',
      type: 'collection',
      href: '',
      items: [
        {
          id: 'es/vit',
        },
        {
          id: 'de/fra',
        },
      ],
    },
  },
};
